import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-one-page-hero',
    templateUrl: './one-page-hero.component.html',
    styleUrls: ['./one-page-hero.component.scss'],
    standalone: false
})

export class OnePageHeroComponent extends BlockAbstractComponent implements OnInit {

}
